import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { LogIn, Lock, Mail, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const LoginPage = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard-profesora"} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email.trim(), password);
      navigate(u.role === "admin" ? "/admin" : "/dashboard-profesora", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell" data-testid="login-page">
      <Link to="/" className="auth-back" data-testid="login-back">
        <ArrowLeft size={16} />
        <span>Volver al inicio</span>
      </Link>

      <div className="auth-card">
        <div className="auth-icon-wrap">
          <Lock size={22} />
        </div>
        <h1 className="auth-title" data-testid="login-title">Acceso interno</h1>
        <p className="auth-subtitle">
          Inicia sesión para administrar tus clases.
        </p>

        <form onSubmit={onSubmit} className="auth-form">
          <label className="auth-field">
            <span className="auth-label">
              <Mail size={14} /> Correo electrónico
            </span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="profesora@labsecreto.academy"
              className="auth-input"
              data-testid="login-email"
            />
          </label>

          <label className="auth-field">
            <span className="auth-label">
              <Lock size={14} /> Contraseña
            </span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="auth-input"
              data-testid="login-password"
            />
          </label>

          {error && (
            <div className="auth-error" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="auth-submit"
            disabled={loading}
            data-testid="login-submit"
          >
            <LogIn size={16} />
            <span>{loading ? "Ingresando…" : "Iniciar sesión"}</span>
          </button>
        </form>

        <p className="auth-footnote">
          Acceso exclusivo para profesoras y administración.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
